import React, { useEffect, useState } from "react";
import Loader from "../../assets/img/loader.gif";

function TabComponent({
  handleStatusChange,
  linkActive,
  countCallAttempted,
  countFollowup,
  countLOST,
  countNew,
  countOpen,
  countWon,
  countconatactInFuture,
  countintergrationInPro,
  countnegotiation,
  countproposal,
  status,
  loader, // ADD THIS
}) {

  const tabs = [
    { label: "New", value: "new", count: countNew },
    { label: "Call Attempted", value: "call-attempted", count: countCallAttempted },
    { label: "Contact in future", value: "contact-in-future", count: countconatactInFuture },
    { label: "Follow-up", value: "follow-up", count: countFollowup },
    { label: "Proposal", value: "proposal", count: countproposal },
    { label: "Negotiation", value: "negotiation", count: countnegotiation },
    { label: "In-Integration", value: "integration-inprogress", count: countintergrationInPro },
    { label: "Closed Won- SYTS", value: "closed-won-SYTS", count: countWon },
    { label: "Lost", value: "lost", count: countLOST },
    { label: "All", value: "Open", count: countOpen },
  ];

  const handleTabClick = (stageValue) => {
    if (loader) return; // block during API

    handleStatusChange(stageValue); //  only this
    // sessionStorage.setItem("activeTab", value);
    sessionStorage.setItem("activeTab", stageValue);
  };

  return (
    <>
      {status === "Open" && (
        <ul className="nav panel-tabs d-flex flex-wrap">
          {tabs.map((tab) => (
            <li key={tab.value}>
              <a
                role="button"
                onClick={() => handleTabClick(tab.value)}
                className={linkActive === tab.value ? "active" : ""}
                style={{
                  pointerEvents: loader ? "none" : "auto",
                  opacity: loader ? 0.6 : 1,
                }}
              >
                {tab.label} ({tab.count})
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

export default TabComponent;